import Vue from "vue";
import VueI18n from "vue-i18n";
import { pluralizationRules } from "./utils/pluralization";
import { localeForBrowserTag, validStoredLocale } from "./utils/localeInfra";

Vue.use(VueI18n);

// При изменении языка переключаем файл /locals/_language_.json
function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const messages = loadLocaleMessages();

// Определяем предустановленный язык браузера и устанавливаем его при запуске.
// Разбор тега и правила сопоставления — в localeForBrowserTag (utils/localeInfra).
function detectLanguage() {
  const tag = window.navigator.userLanguage || window.navigator.language;
  return localeForBrowserTag(tag, Object.keys(messages));
}

// Сохранённый язык мог быть удалён из проекта (так ушёл хинди) — тогда его
// нельзя подставлять в $i18n.locale. Чиним хранилище один раз, при старте.
function storedLanguage() {
  const stored = localStorage.getItem("lang");
  const valid = validStoredLocale(stored, Object.keys(messages));
  if (stored && !valid) localStorage.removeItem("lang");
  return valid;
}

const FALLBACK_LOCALE = process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en";

export default new VueI18n({
  // Хвост — именно fallback-локаль, а не VUE_APP_I18N_LOCALE: этой переменной
  // нет ни в одном .env, и её undefined ставил locale в "en-US" — код, которого
  // нет ни среди файлов локалей, ни в селекторах языка (селектор оставался
  // пустым). Ровно сюда попадает браузер с языком, для которого перевода нет.
  locale: storedLanguage() || detectLanguage() || process.env.VUE_APP_I18N_LOCALE || FALLBACK_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages,
  // Три формы (1 | 2–4 | 5+) для ru/pl/sr/ro/hr — см. utils/pluralization.js
  pluralizationRules,
});